import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcListConfig} from 'exc-controls';
import {ExcTab} from 'exc-tab';
import {DealerDetailsComponent} from '../dealer-details/dealer-details.component';
import {AuditDetailsComponent} from '../audit-details/audit-details.component';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ReportService} from '../report-service.service';



@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent extends ExcTranslation implements OnInit {
  audits = [];
  @ViewChild('popup') popup;
  @ViewChild('reportPopup') reportPopup;
  selected = {year: (new Date()).getFullYear(), month:  (new Date()).getMonth() + 1 };
  optionsMonth: any[] = [];
  optionsYear: any[] = [];
  popupData = {Year: (new Date()).getFullYear(), Month: (new Date()).getMonth() + 1  };
  data = {AuditStates: [], Monthly: [], OnTime: [], Schedule: {Yesterday: [], Today: [], Tomorrow: []}, Charts: []};
  listConfigYesterday: ExcListConfig = new ExcListConfig();
  listConfigToday: ExcListConfig = new ExcListConfig();
  listConfigTomorrow: ExcListConfig = new ExcListConfig();
  search = {Yesterday: '', Today: '', Tomorrow: ''};
  isLoading = true;
  constructor(private excrest: ExcRestService, private excDss: DefaultSettingsService, private reportService: ReportService) {
    super();
    const _self = this;
    for (let i = 1; i <= 12; i++) {
      _self.optionsMonth.push({text: i, value: i});
    }
    for (let i = -3; i <= 3; i++) {
      _self.optionsYear.push({text: (new Date()).getFullYear() + i, value: (new Date()).getFullYear() + i});
    }

    _self.listConfigYesterday.selectionMode = 'none';
    _self.listConfigYesterday.paging = {pageNo: 1, pageSize: 5};
    _self.listConfigYesterday.OnRefresh = () => {
      _self.loadList('Yesterday');
    };
    _self.listConfigYesterday.OnPageChanged = (pageNo) => {
      _self.listConfigYesterday.paging.pageNo = pageNo;
      _self.loadList('Yesterday');
    };
    _self.listConfigYesterday.OnSearch = (searchValue) => {
      _self.search.Yesterday = searchValue;
      _self.loadList('Yesterday');
    };
    _self.listConfigToday.selectionMode = 'none';
    _self.listConfigToday.paging = {pageNo: 1, pageSize: 5};
    _self.listConfigToday.OnRefresh = () => {
      _self.loadList('Today');
    };
    _self.listConfigToday.OnPageChanged = (pageNo) => {
      _self.listConfigToday.paging.pageNo = pageNo;
      _self.loadList('Today');
    };
    _self.listConfigToday.OnSearch = (searchValue) => {
      _self.search.Today = searchValue;
      _self.loadList('Today');
    };

    _self.listConfigTomorrow.selectionMode = 'none';
    _self.listConfigTomorrow.paging = {pageNo: 1, pageSize: 5};
    _self.listConfigTomorrow.OnRefresh = () => {
      _self.loadList('Tomorrow');
    };
    _self.listConfigTomorrow.OnPageChanged = (pageNo) => {
      _self.listConfigTomorrow.paging.pageNo = pageNo;
      _self.loadList('Tomorrow');
    };
    _self.listConfigTomorrow.OnSearch = (searchValue) => {
      _self.search.Tomorrow = searchValue;
      _self.loadList('Tomorrow');
    };
    // _self.listConfigYesterday.OnFilterClick = (event?) => _self.filterMenu.toggle(event);
    // _self.listConfigYesterday.OnFilter = () => {
    // };
  }

  ngOnInit() {
    const _self = this;
    _self.loadData();
  }

  loadData() {
    const _self = this;
    _self.isLoading = true;
    _self.listConfigTomorrow.isLoading = true;
    _self.listConfigToday.isLoading = true;
    _self.listConfigYesterday.isLoading = true;
    const mi = _self.listConfigTomorrow.GetMetaInfo();
    mi['dataPaging']['pageSize'] = 5;
    mi['dataPaging']['pageNo'] = 1;
    _self.excrest.sget(_self.excrest.computeUrl('Dashboard', {
      month: _self.selected.month, year: _self.selected.year
    }), ExcCoreModule.Guid.NewGuid(), {MetaInfo: mi}).subscribe(response => {
      if (response.response !== undefined) {
        _self.data.AuditStates = response.response.data.AuditStates;
        _self.data.Monthly =  response.response.data.AuditsMonthly;
        _self.data.OnTime =  response.response.data.AuditOnTime;
        _self.data.Schedule.Yesterday = response.response.data.ScheduleYesterday;
        _self.data.Schedule.Today = response.response.data.ScheduleToday;
        _self.data.Schedule.Tomorrow = response.response.data.ScheduleTomorrow;
        _self.listConfigYesterday.paging = response.response.paging.ScheduleYesterday;
        _self.listConfigToday.paging = response.response.paging.ScheduleToday;
        _self.listConfigTomorrow.paging = response.response.paging.ScheduleTomorrow;
        _self.data.Charts = response.response.data.Charts;
        _self.listConfigTomorrow.isLoading = false;
        _self.listConfigToday.isLoading = false;
        _self.listConfigYesterday.isLoading = false;
         _self.isLoading = false;
      }
    });
    /*  [xScale]="xScale"
      [yScale]="yScale"
      [colors]="colors"
      [data]="series"
      [scaleType]="scaleType"
      [curve]="curve"
      [animations]="animations"*/
  }
  getAvatarTooltip(data) {
    let t = '';
    t = this.getGlobal('AuditType_' + data.AuditType);
    if ((data.AuditType === 35 || data.AuditType === 16) && data.AuditPartialResult === true) {
      t = t + ' (' + this.getGlobal('PartialResults') + ')';
    }
    return t;
  }
  loadStrip() {
    const _self = this;
    const url = _self.excrest.computeUrl('DashboardR_LandingStrip', {month: _self.selected.month, year: _self.selected.year});
    _self.excrest.get(url, {}).subscribe(ret => {
      if (ret) {
        _self.data.AuditStates = ret.AuditStates;
      }
    });
  }
  loadList(name) {
    const _self = this;
    const mi = _self['listConfig' + name].GetMetaInfo();
    mi['dataPaging']['pageSize'] = 5;

    const url = _self.excrest.computeUrl('DashboardR_Schedule', {day: name, fts: _self.search[name].length > 0 ? _self.search[name] : null});
    _self['listConfig' + name].isLoading = true;
    _self.data.Schedule[name] = [];
    _self.excrest.get(url, {MetaInfo: mi}).subscribe(response => {
      if (response) {
        _self.data.Schedule[name] = response.data;
        _self['listConfig' + name].paging = response.paging;
      }
      _self['listConfig' + name].isLoading = false;

    });
  }
  isOnStrip(key) {
      const textTypes = [1, 2, 3, 4, 5, 7];
      return textTypes.indexOf(key)  !== -1 ;
  }

  cancelPopup(e) {
    const _self = this;
    _self.popup.hide(e);
  }

  applyPopup(e) {
    const _self = this;
    _self.popup.hide(e);
    _self.selected.year = this.popupData.Year;
    _self.selected.month = this.popupData.Month;
_self.loadStrip();
  }


  getAvatarClass(data) {
    if (data.AuditType === 16 || data.AuditType === 35) {
      if (data.AuditPartialResult === true) {
        return 'fa-mobile th-danger';
      }
      if (data.AuditIsPicked) {
        return 'fa-mobile th-warning';
      } else {
        return 'fa-mobile th-secondary';
      }
    } else {
      if (data.AuditIsPicked) {
        return 'fa-user-secret th-warning';
      } else {
        return 'fa-user-secret th-secondary';
      }
    }
  }
  getAttractorTip(data) {
    if (data.AuditType === 16 || data.AuditType === 35) {
      switch (data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
        case 8:
        case 9:
          if (data.ScRejected === true) {
            return this.getGlobal('Rejected');
          } else {
            if (data.ScEnded === true) {
              return this.getGlobal('Done');
            } else {
              return this.getGlobal('Expired');
            }
          }
        case 10:
          return this.getGlobal('Cancelled');
      }
    } else {
      switch (data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
        case 4:
        case 5:
        case 6:
        case 7:
          return this.getGlobal('InProgress');
        case 8:
        case 9:
          return this.getGlobal('Done');
        case 10:
          return this.getGlobal('Cancelled');
      }
    }
  }
  getAttractorClass(data) {
    if (data.AuditType === 16 || data.AuditType === 35) {
      switch (data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
          break;
        case 8:
        case 9:
          if (data.ScRejected === true) {
            return 'ch-danger fa-exclamation';
          } else {
            if (data.ScEnded === true) {
              return 'ch-success fa-check';
            } else {
              return 'ch-warning fa-clock';
            }
          }
          break;
        case 10:
          return 'ch-warning fa-ban';
          break;
      }
    } else {
      switch (data.AuditStatus) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          return 'ch-secondary fa-cogs';
          break;
        case 8:
        case 9:
          return 'ch-success fa-check';
          break;
        case 10:
          return 'ch-warning fa-ban';
          break;
      }
    }
  }
  openDealer(data) {
    new ExcTab(data.DealerName , DealerDetailsComponent, {
      DealerID: data.DealerID,
    }, data.DealerID, {Unique: true}, true).Open();
  }
  openAudit(data) {
    new ExcTab(data['DealerName'] + ' - ' + data.AuditID, AuditDetailsComponent, data, data.AuditID, {
      Unique: true, ReloadParent: function () {
        // _self.initialLoad();
      }
    }, true).Open();
  }
  showReports() {
    const _self = this;
    _self.reportService.ShowModal('Dashboard', null).subscribe(x => {});
  }
  showPopup(e) {
    const _self = this;
    _self.popup.show(e);
  }
}
